import React, { Component, Fragment } from 'react'
import { SpinnerCard } from '../common/Layout'
import { PanelNotificationPreferences } from './PanelNotificationPreferences'
import { PanelPrivacyPreferences } from './PanelPrivacyPreferences'
import {
  loadNotificationPreferencesStart,
  updateNotificationPreferenceStart,
} from '../../redux/modules/preferences'
import {
  getUserPrivacyStart,
  updateUserPrivacyStart,
} from '../../redux/modules/profile'
import { connect } from 'react-redux'

class ProfileSidebar extends Component {
  constructor(props) {
    super(props)
    this.props.loadNotificationPreferencesStart()
  }

  componentDidUpdate() {
    const {
      privacy,
      profile,
      getUserPrivacyStart,
      userPrivacyLoading,
      updateUserPrivacyError,
    } = this.props
    if (!privacy && !userPrivacyLoading && profile && !updateUserPrivacyError) {
      getUserPrivacyStart()
    }
  }

  render() {
    const {
      notificationPreferences,
      isLoadingNotificationPreferences,
      updateNotificationPreferenceStart,
      isUpdatingPreference,
      error,
      userPrivacyLoading,
      privacy,
      updateUserPrivacyStart,
      updateUserPrivacyError,
    } = this.props
    return (
      <Fragment>
        <SpinnerCard spinnerActive={isLoadingNotificationPreferences}>
          <PanelNotificationPreferences
            error={error}
            isLoadingNotificationPreferences={isLoadingNotificationPreferences}
            isUpdatingPreference={isUpdatingPreference}
            notificationPreferences={notificationPreferences}
            updateNotificationPreferenceStart={
              updateNotificationPreferenceStart
            }
          />
        </SpinnerCard>
        <SpinnerCard
          spinnerActive={
            userPrivacyLoading || (!privacy && !updateUserPrivacyError)
          }
        >
          <PanelPrivacyPreferences
            privacy={privacy}
            updateUserPrivacyError={updateUserPrivacyError}
            updateUserPrivacyStart={updateUserPrivacyStart}
          />
        </SpinnerCard>
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  const {
    notificationPreferences,
    isLoadingNotificationPreferences,
    isUpdatingPreference,
    error,
  } = state.preferences
  const {
    privacy,
    userPrivacyLoading,
    updateUserPrivacyError,
    profile,
  } = state.profile

  return {
    notificationPreferences,
    isLoadingNotificationPreferences,
    isUpdatingPreference,
    error,
    userPrivacyLoading,
    privacy,
    updateUserPrivacyError,
    profile,
  }
}

const mapDispatchToProps = {
  loadNotificationPreferencesStart,
  updateNotificationPreferenceStart,
  getUserPrivacyStart,
  updateUserPrivacyStart,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProfileSidebar)
